import React, { useState, useEffect } from "react";
import { Row, Col, Card, Spinner, Alert } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import CreateNewMSRCategory from "@/components/CreateNewMSRCategory";
import { useMsrManagementService } from "@/services/msrManagementService";
import { useGeneralApiCall } from "../services/useGeneralApiCall";
import { useNavigate } from "react-router-dom";
import { showToast } from "@/api/notification";

type SeasonStyle = {
  id: number;
  name: string;
  cover_image: string;
  style_id: string;
};
type SeasonYearDetail = {
  msr_season_year_id: string;
  msr_year_id: string;
  year: number;
  year_slug: string;
  msr_season_id: string;
  season_name: string;
  cover_image: string;
  slug: string;
};

const MSRSeasonDetail: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get("id");
  const yearid = searchParams.get("yearid");

  const { getApi } = useGeneralApiCall();
  // const [detail, setDetail] = useState<SeasonYearDetail | null>(null);
  const [detail, setDetail] = useState<SeasonYearDetail | null>(null);
  const [isEditing, setIsEditing] = useState(false);
  const [mockStyles, setmockStyle] = useState<SeasonStyle[]>([]);
  const { fetchSingleMsrSeasonYear, UpdateMsrSeasonYear } =
    useMsrManagementService();

  const getSingleMsrSeasonYear = async (yearid: string) => {
    try {
      const response: any = await fetchSingleMsrSeasonYear(yearid);
      setDetail(response.data);
    } catch (err) {
      console.error("Failed to load season detail", err);
    }
  };

  const getMSRStyledata = async () => {
    try {
      const response1: any = await getApi(
        `api/msr/v1/msrseasonyear-style/${yearid}/`
      );
      if (response1.status === 200) {
        setmockStyle(response1.data);
      }
    } catch (error: any) {}
  };

  const singleApiData = async () => {
    if (yearid) {
      const response: any = await fetchSingleMsrSeasonYear(yearid);
      if (response.status === 200) {
        setDetail(response.data);
        getSingleMsrSeasonYear(yearid);
        getMSRStyledata();
        showToast({ message: response.message, type: "success" });
      }
    }
  };

  useEffect(() => {
    if (yearid && id) {
      getSingleMsrSeasonYear(yearid);
      getMSRStyledata();
    }
  }, [yearid, id]);

  if (!detail) {
    return (
      <div className="mt-4 text-center">
        <Spinner animation="border" />
      </div>
    );
  }

  const handleUpdateMsrCategory = async (formData: FormData) => {
    const temp: string = yearid as string;
    UpdateMsrSeasonYear(temp, formData);
    singleApiData();
  };

  return (
    <div className="m-12">
      <Row className="align-items-center mb-5">
        <Col md={6}>
          <div className="w-full flex justify-center">
            <img
              src={detail.cover_image}
              alt="Cover"
              className=" object-contain w-auto h-[60vh] rounded-lg aspect-[0.67]"
            />
          </div>
        </Col>
        <Col md={6}>
          <CreateNewMSRCategory
            year_label="Year"
            season_label="Season"
            cover_image_label="Change Cover Image"
            year_value={detail.year}
            year_slug={detail.year_slug}
            season_value={detail.season_name}
            season_slug={detail.slug}
            isEditing={isEditing}
            setIsEditing={setIsEditing}
            edit_button_visible={true}
            create_button_visible={false}
            handleUpdateMsrCategory={handleUpdateMsrCategory}
            getMsrYearWiseSeason={() => {}}
            singleApiData={singleApiData}
          />
        </Col>
      </Row>

      <Alert className="text-center">MSR Styles</Alert>
      <Row>
        {mockStyles.map((style: SeasonStyle, index: number) => (
          <Col
            key={index}
            xs={6}
            sm={4}
            md={3}
            className="mb-4"
            onClick={() => navigate(`/style/details/${style.style_id}`)}
          >
            <Card className="h-100 shadow-sm">
              <Card.Img
                variant="top"
                src={
                  style.cover_image
                    ? style.cover_image
                    : "/images/dummy_image.jpg"
                }
                alt={style.name}
              />
              <Card.Body className="d-flex align-items-center justify-content-center">
                <Card.Title className="fs-6 text-center mb-0">
                  {style.name}
                </Card.Title>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default MSRSeasonDetail;
